import { render, staticRenderFns } from "./CreatedContents.vue?vue&type=template&id=ffd95d54&scoped=true&"
import script from "./CreatedContents.vue?vue&type=script&lang=js&"
export * from "./CreatedContents.vue?vue&type=script&lang=js&"
import style0 from "./CreatedContents.vue?vue&type=style&index=0&id=ffd95d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd95d54",
  null
  
)

export default component.exports